import { countries } from 'countries-list';
import { AU_STATES, BR_STATES, CA_STATES, JP_STATES, MILITARY_US_STATES, UNSUPPORTED_COUNTRIES, US_STATES, } from './consts';
export const isEmpty = (value) => {
    return value ? value.trim().length === 0 : true;
};
export const isStringLatin = (value) => {
    const latinCharactersClasses = /\p{Script=Latin}\p{White_Space}\p{Punctuation}\p{Number}\n/gu
        .source;
    return new RegExp(`^[${latinCharactersClasses}]*$`, 'gu').test(value);
};
export const isPhoneNumber = (value) => {
    return /^\+?(?!.*\+.*)(?=(?:\D*\d){6,17}$)(?=[^(]*(?:\([^(]*\))*[^(]*$)(\(?[0-9]{1,3}\)?)?[ -]?\(?0?[0-9]{1,4}\)?([ -.]?[0-9]{1,4}){2,6}$/.test(value);
};
export const isUSZipCode = (value) => {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);
};
export const isCAZipCode = (value) => {
    return /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s-]?\d[ABCEGHJ-NPRSTV-Z]\d$/gi.test(value);
};
export const isAUZipCode = (value) => {
    return /^(0[289][0-9]{2})|([123456789][0-9]{3})$/g.test(value);
};
export const isCPFNumber = (value) => {
    return /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(value);
};
// CURP
// - First letter can be any uppercase
// - Second letter must be A,E,I,O,U,X
// - Next 2 letters can be any uppercase
// - Date format (YYMMDD) with proper month/day validation
// - Gender (M/H)
// - Following 4 letters must be consonants (excluding some letters)
// - Last 2 characters alphanumeric
export const isCURPNumber = (value) => {
    return /^[A-Z][AEIOUX][A-Z]{2}\d{2}[0-1]\d[0-3]\d[MH][A-Z][BCDFGHJKLMNÑPQRSTVWXYZ]{4}[\dA-Z]\d$/i.test(value);
};
// RFC
// - 3 or 4 letters (including Ñ and &)
// - Date format (YYMMDD) with proper month/day validation
// - Optional 3 character homoclave
export const isRFCNumber = (rfc) => {
    // define regex pattern
    const pattern = /^[A-ZÑ&]{3,4}\d{2}[0-1]\d[0-3]\d([A-Z\d]{3})?$/i;
    // test overall structure
    if (!pattern.test(rfc))
        return false;
    // extract date
    const dateMatch = rfc.match(/^[A-Z&Ñ]{3,4}(\d{6})/i);
    if (!dateMatch)
        return false;
    // extract YYMMDD
    const dateString = dateMatch[1];
    const year = parseInt(dateString.substring(0, 2));
    const month = parseInt(dateString.substring(2, 4));
    const day = parseInt(dateString.substring(4, 6));
    // validate month (1-12)
    if (month < 1 || month > 12)
        return false;
    // validate day based on the month and year (leap year logic for February)
    const daysInMonth = new Date(2000 + year, month, 0).getDate(); // `2000 + year` for RFC logic
    if (day < 1 || day > daysInMonth)
        return false;
    return true;
};
export const getCountries = () => {
    let allCountries = countries;
    const filtered = Object.keys(allCountries)
        .filter((key) => !UNSUPPORTED_COUNTRIES.includes(key))
        .sort((a, b) => {
        const countryA = allCountries[a].name;
        const countryB = allCountries[b].name;
        return countryA.localeCompare(countryB);
    })
        .reduce((acc, key) => {
        const countryCode = key;
        acc[countryCode] = allCountries[countryCode];
        return acc;
    }, {});
    return filtered;
};
export const getCountryNameByCode = (countryCode) => getCountries()[countryCode].name;
export const getStateNameByCode = (countryCode, stateCode) => {
    const STATES = {
        US: [...US_STATES, ...MILITARY_US_STATES],
        CA: CA_STATES,
        JP: JP_STATES,
        AU: AU_STATES,
        BR: BR_STATES,
    };
    if (STATES[countryCode])
        STATES[countryCode]?.find(({ abbreviation }) => abbreviation === stateCode)?.name || stateCode;
    return stateCode;
};
